import React from "react";

import { Checkbox, DateRange } from "components/form_components/Inputs";
import { BidFilterContentProps, StyledFilterContent } from "./utils";

function AwardDateFilterContent({ control }: BidFilterContentProps) {
  return (
    <StyledFilterContent aria-label="Award date filter">
      <DateRange name="awardDate.filter" control={control} label="" />
      <Checkbox
        label=""
        name="awardDate.hideNulls"
        control={control}
        fieldLabel="Hide bids that don't have an award date"
      />
    </StyledFilterContent>
  );
}

export default AwardDateFilterContent;
